import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD8x9O164h9gXxcEMW0cqzkNY8U_ZdheyA",
  authDomain: "data-axe-401820.firebaseapp.com",
  projectId: "data-axe-401820",
  storageBucket: "data-axe-401820.firebasestorage.app",
  messagingSenderId: "124679488593",
  appId: "1:124679488593:web:c48c0c55023bb6e56ea470",
  measurementId: "G-WN6H3ETVSL"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, 'prd-advisors-management');
